import { IconBox, MailClickIcon } from "@hightouch/htui";
import { SchemaIconProps } from "./types";

/**
 * @important
 * Always ensure svg within the wrapper is set to 100% size and has no width/height props so that it fits to the wrapper.
 */
export const MessageEventIcon = ({
  size = "xl",
  ...props
}: SchemaIconProps) => {
  return (
    <IconBox color="orange" icon={<MailClickIcon />} size={size} {...props} />
  );
};
